enum Gender {
  male,
  female,
  unisex,
}

export default Gender;
